var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobCalibraShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff145;}.cls-2{fill:#14635b;}.cls-3{fill:#283331;}.cls-4{fill:#1c7f78;}.cls-5{fill:aqua;}.cls-6{fill:#003834;}.cls-7{fill:#0f4c45;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "580.62 383.69 546.81 388.77 476.46 388.77 476.46 328.88 580.62 344.53 580.62 383.69"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "379.55 274.58 367.96 318.03 3.78 377.19 525.99 378.72 643.46 274.17 379.55 274.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "520.98 403.67 92.7 396.61 3.78 377.19 523.8 379.06 520.98 403.67"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "598.21 476.88 394.16 452.22 375.73 438.05 592.86 460.91 598.21 476.88"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "416.12 425.95 167.43 416.01 167.43 411.54 416.12 401.6 416.12 425.95"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "593.35 460.91 376.19 438.51 346.77 378.78 525.62 379.06 593.35 460.91"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.32 377.49 394.03 291.96 503.14 307.41 3.32 377.49"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.32 377.49 503.14 307.41 597.76 307.41 570.08 339.83 3.32 377.49"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "394.03 291.96 214.45 291.96 703.32 229.76 643.59 274.13 394.03 291.96"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "643.59 274.13 214.45 291.96 570.08 339.83 643.59 274.13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCalibraShip);
export default __webpack_public_path__ + "static/media/mob-calibra-ship.fce194b0d6382cfa6e65b14ab6189d1d.svg";
export { ForwardRef as ReactComponent };